// <mable-heading heading="h1"> hello h1</mable-heading>
// <mable-heading heading="h2"> hello h2</mable-heading>
// <mable-heading heading="h2-profile"> hello h2-profile</mable-heading>
// <mable-heading heading="h3"> hello h3</mable-heading>
// <mable-heading heading="h3" [nested]="true"> hello h3</mable-heading>
// <mable-heading heading="h4"> hello h4</mable-heading>
// <mable-heading heading="h5"> hello h5</mable-heading>

import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeadingColor, HeadingStyle, HeadingType } from 'src/app/shared/components/heading/heading.types';
import { Require } from '../component.util';

@Require<HeadingComponent>(['heading'])
@Component({
  selector: 'mable-heading',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss'], // Supports ion-no-margin ion-no-padding
})
export class HeadingComponent {
  // Used to identify heading type
  @Input() heading: HeadingType = 'h2';

  // Used to apply color to the heading
  @Input() color: HeadingColor = 'grey-500';

  // Add template classes to host. Workaround for hostBinding class reset.
  @Input() class = '';

  // Used to add icon to the heading
  @Input() icon = '';

  // User to add aria-label to the icon
  @Input() iconAriaLabel = '';

  // Used to specify icon colour
  @Input() iconColor = null;

  // heading style to show heading like other headings
  @Input() headingStyle: HeadingStyle;

  /**
   * Attach styling classes to the host element
   *
   */
  @HostBinding('class') get classes() {
    return `
    ${this.class}
    ion-color-${this.getHeadingColor()}
    `;
  }

  /**
   * Return the color to be applied on the heading.
   *
   */
  getHeadingColor() {
    return this.color || 'grey-500';
  }
}
